import React, { useEffect, useState } from "react";

import Select from "react-select";

import ReactDatetime from "react-datetime";

import moment from "moment";
import jsPDF from "jspdf";

import { MDBInput } from "mdb-react-ui-kit";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip,
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";

import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import DatePicker from "../../components/DatePicker/Datepicker.js";
import { withRouter } from "react-router-dom";

import {
  SMS_FALLBACK,
  Whatsapp_CAMPAIGN_REPORTS,
  WHATSAPP_CAMPAIGN_LIST_DATE,
  WHATSAPP_DAYWISE_EXCEL,
  CHANNEL_CLIENT_CHNLTYPE
} from "../../constants.js";
import axios from "axios";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import autoTable from "jspdf-autotable";
import LoadingScreen from "react-loading-screen";
//import logo from "../../../assets/img/logo.png";
import logo from "../../assets/img/logo.png";
import ResponsivePagination from 'react-responsive-pagination';

let templates = [];
let senderids = [];
let campaigns = []

const localJson = localStorage.getItem("user");
const user = JSON.parse(localJson)
const SmsFallBackReport = (props) => {
  let totlsent = 0;
  let totldeliver = 0;
  let totlfail = 0;
  const notificationAlertRef = React.useRef(null);
  const [daywiseList, setDaywiseList] = useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorhandle, setErrorHandle] = useState()
  const [channel, setChannel] = useState([]);

  const [search, setSearch] = useState({
    fromdate: "",
    todate: "",
    templateid: "",
    campaignname: "",
    senderid: ""
  });
  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });
  const [currentPage, setCurrentPage] = React.useState(1);

  useEffect(() => {
    fetchChanelsbyClient()

  }, []);

  const fetchChanelsbyClient = () => {

    //setIsLoading(true)

    const payload = {
      channels_type: "sms",
      clintId: user?.client
    }

    axios.post(CHANNEL_CLIENT_CHNLTYPE, payload).then(res => {

      templates = []
      setChannel(res?.data)


      res?.data?.map((wtsap, i) => {
        wtsap?.template && templates.push({ value: wtsap?.template, label: wtsap?.template },)

      })

      setIsLoading(false)
    }).catch(e => {
      setIsLoading(false)
      let options = {};
      options = {
        place: "tr",
        message: "Templates Not Found",
        type: "warning",
        autoDismiss: 2,
      };
      notificationAlertRef?.current?.notificationAlert(options);
    })

  }

  const changeSender = (data) => {
    senderids = []
    const chnl = channel.filter(item => item.template == data.value)

    const senderid = chnl[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      senderids.push({ label: senderid[i], value: senderid[i] })
    }


    setSearch(prev => ({ ...prev, templateid: data, senderid: "" }))
  }


  const submitHandler = async (page) => {

    setCurrentPage(page)
    const isValid = validatedate();
    setErrorHandle(isValid)
    if (Object.keys(isValid).length == 0) {
      let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
      let todate = moment(search.todate).format("YYYY-MM-DD");


      let lclstrg = localStorage.getItem("user");
      let user = JSON.parse(lclstrg);

      const payload = {
        fromdate: fromdate,
        todate: todate,
        client_id: user.client,
        campaign: search?.campaignname?.value,
        templateid: search?.templateid?.value,
        senderid: search?.senderid?.value || user.sender_id,
        channel: "sms"
      }


      setIsLoading(true)
      await axios
        .get(`${SMS_FALLBACK}?fromdate=${fromdate}&todate=${todate}&client_id=${user.client}&senderid=${search?.senderid?.value}&templateid=${search?.templateid?.value}&page=${page}`)

        .then((res) => {
          setDaywiseList(res.data);
          setIsLoading(false)
        })
        .catch((err) => console.log("error====>", err));
    }
  };
  const validatedate = () => {
    let errors = {}
    if (!search.fromdate) {
      errors.fromdate = "Please Select From Date"
    } if (!search?.todate) {
      errors.todate = "Please Select To Date"
    }
    if (!search?.templateid?.value) {
      errors.templateid = "Please Select Template"
    }
    if (!search?.senderid?.value) {
      errors.senderid = "Please Select Senderid"
    }


    return errors;
  }


  const downloaddaywiseexcel = async (date) => {
    const isValid = validatedate();
    setErrorHandle(isValid)
    if (Object.keys(isValid).length == 0) {
      setIsLoading(true)
      let fromdate = moment(date).format("YYYY-MM-DD");
      let todate = moment(date).format("YYYY-MM-DD");


      let lclstrg = localStorage.getItem("user");
      let user = JSON.parse(lclstrg);

      const payload = {
        fromdate: fromdate,
        todate: todate,
        client_id: user.client,
        campaign: search?.campaignname?.value,
        channel: "sms"
      }
      await axios
        .post(
          WHATSAPP_DAYWISE_EXCEL, payload

        )
        .then((res) => {
          setIsLoading(false)
          const body =
            res.data.message.length > 0 ? res.data.message : "No Records";

          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(body);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, todate + fileExtension);

        })
        .catch((err) => console.log("error====>", err));
    }
  };




  const toDatevalidation = async (todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
      const payload = {
        fromdate: fromdate,
        todate: todate,
        client_id: user?.client,
        channel: "sms"
      }

      await axios.post(WHATSAPP_CAMPAIGN_LIST_DATE, payload).then(res => {
        console.log(res?.data.message);
        res?.data?.message?.map((item, index) => {
          campaigns.push({ label: item.campaign, value: item.campaign })
        });

      }).catch(e => {
        console.log("Error==>", e);
      })
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };


  const downloadexcel = async () => {
    const isValid = validatedate();
    setErrorHandle(isValid)
    if (Object.keys(isValid).length == 0) {
      setIsLoading(true)
      let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
      let todate = moment(search.todate).format("YYYY-MM-DD");


      let lclstrg = localStorage.getItem("user");
      let user = JSON.parse(lclstrg);

      const payload = {
        fromdate: fromdate,
        todate: todate,
        client_id: user.client,
        campaign: search?.campaignname?.value,
        channel: "sms"
      }
      await axios
        .post(
          Whatsapp_CAMPAIGN_REPORTS, payload

        )
        .then((res) => {
          setIsLoading(false)
          const body =
            res.data.message.length > 0 ? res.data.message : "No Records";

          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(body);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, todate + fileExtension);

        })
        .catch((err) => console.log("error====>", err));
    }
  };


  return (
    <>
      <div className="content pb-0">
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                <Row>
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });

                      }}
                    />
                    <span style={{ color: "red" }}>{errorhandle?.fromdate}</span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        toDatevalidation(val._d);
                        //  fetchCampaigns()
                      }}
                    // onChange={(val) =>{setSearch({...search,todate:val._d});setValidate({
                    //   message:"",
                    //   notValid:false
                    // } )}}
                    />
                    <span style={{ color: "red" }}>{errorhandle?.todate}</span>
                    <span style={{ color: "red" }}>{validate?.message}</span>

                  </Col>

                  <Col md="3" sm="12">
                    <p className="category">Select Template<suf style={{ color: "red" }}>*</suf> </p>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="templateSelect"
                      value={search.templateid}
                      onChange={(value) => changeSender(value)}
                      options={templates}
                      placeholder="Select"
                    />
                    {errorhandle?.templateid && <span style={{ color: "red" }}>{errorhandle?.templateid}</span>}
                  </Col>

                  <Col md="3" sm="12">
                    <p className="category">Select Sender<suf style={{ color: "red" }}>*</suf> </p>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="senderSelect"
                      value={search?.senderid}
                      onChange={(value) => setSearch(prev => ({ ...prev, senderid: value }))}
                      options={senderids}
                      placeholder="Select"
                    />
                    {errorhandle?.senderid && <span style={{ color: "red" }}>{errorhandle?.senderid}</span>}
                  </Col>



                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => submitHandler(currentPage)}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>

                    {/* <Button
                      className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right"
                      color="primary"
                      data-placement="top"
                      id="tooltipexcel"
                      type="button"
                      onClick={() => downloadexcel()}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </Button> */}
                    {/* <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltipexcel"
                    >
                      Excel
                    </UncontrolledTooltip> */}
                  </Col>
                </Row>

                {/* {
                  daywiseList?.summary?.map((item, index) => {
console.log(item);
                    if (item === "SENT") {
                      totlsent = totlsent + 1;
                    } else if (item === "delivered") {
                      totldeliver = totldeliver + 1;

                    } else if (item === "failed") {
                      totlfail = totlfail + 1;

                    }
                  })
                } */}
                {
                  console.log(daywiseList?.summary)
                }
       
                <Row className="blockquote blockquote-primary reports_smsstyles text-center ml-0 mr-0 mt-3" >
                  <Col sm="6" lg="2"><p>Total Count <span>{daywiseList?.totalcampaigns || 0}</span> </p></Col>
                  <Col sm="6" lg="1"><p> Sent <span>{daywiseList?.summary?daywiseList?.summary[0]?.SENT : 0}</span> </p></Col>
                  <Col sm="6" lg="2"><p> Delivered <span>{daywiseList?.summary?daywiseList?.summary[0]?.DELIVERED : 0}</span> </p></Col>
                  <Col sm="6" lg="1"><p> Failed  <span>{daywiseList?.summary?daywiseList?.summary[0]?.FAILED : 0}</span> </p></Col>
                  <Col sm="6" lg="2"><p>Success Rate   <span>{daywiseList?.totalcampaigns?((((daywiseList?.summary[0]?.DELIVERED) / daywiseList?.totalcampaigns) * 100).toFixed(2) + "%" ): (0+ "%")}</span> </p></Col>
                  <Col sm="6" lg="2"><p>Fail Rate  <span>{daywiseList?.totalcampaigns?(((daywiseList?.summary[0]?.FAILED / daywiseList?.totalcampaigns) * 100).toFixed(2) + "%" ): (0+ "%")}</span> </p></Col>
                  <Col sm="6" lg="2"><p>Avg Time<span>8 sec{}</span> </p></Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
              <CardBody className="mb-0">
                <LoadingScreen
                  children=""
                  loading={isLoading}
                  bgColor="rgba(0,0,0,0.7)"
                  spinnerColor="#9ee5f8"
                  textColor="#676767"
                  logoSrc={logo}
                  text="Loading..."
                ></LoadingScreen>
                <TableContainer component={Paper} className="tableheight">
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th rowspan="2">S no </th>
                        <th rowspan="2">Template </th>
                        <th rowspan="2">Msisdn </th>
                        <th rowspan="2"> Date</th>
                        <th>Status </th>


                      </tr>

                    </thead>
                    <tbody>

                      {daywiseList?.message?.length > 0 ? (
                        daywiseList?.message?.map((row, index) => (
                          <tr
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <td>{index + 1}</td>
                            <td>{row?.templateid}</td>
                            <td>{row?.msisdn}</td>
                            <td> {moment(row.inTime).format("YYYY-MM-DD")}</td>
                            <td>{row.status}</td>
                          </tr>
                        ))
                      ) : (
                        <tr
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <td colSpan={9}>No Records</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
              {daywiseList?.numOfPages > 0 &&
                <div style={{ width: "30%", marginLeft: "auto" }}>
                  <ResponsivePagination
                    current={currentPage}
                    total={daywiseList?.numOfPages}
                    onPageChange={(newPage) => { submitHandler(newPage) }}
                  />
                </div>
              }

            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withRouter(SmsFallBackReport);
